/*eslint no-script-url: 0 */
import React, { Component } from "react";
import FilerobotImageEditor from 'filerobot-image-editor';
import Constants from '../../Config/Config';
import $ from 'jquery';

export default class ImageEditor extends Component {

    constructor(props, context) {
        super(props, context);
        this.toggleFalse = this.toggleFalse.bind(this);
        this.saveImage = this.saveImage.bind(this);
    }

    toggleFalse() {
        this.props.lgClose()
    }

    saveImage() {
        var self = this;
        var canvasThumb = document.getElementById("scaleflex-image-edit-box");
        //console.log(canvasThumb, 'canvasThumb');
        const apiBaseUrl = Constants.URL.root + '/webservices/uploadCanavasCroppedImage.php';

        $.ajax(apiBaseUrl, {
            method: "POST",
            data: { croppedImage: canvasThumb.toDataURL() },
            success: function (res) {
                console.log(res, 'image')
                //self.dispatchImageData(id, res);
                var NImage = new Image();
                NImage.src = res
                NImage.onload = function () {
                    var O = (NImage.src.replace(/.*?:\/\//g, '/'), 0);
                    var P = 0;
                    var Q;
                    O = NImage.width
                    P = NImage.height
                    if (150 < O / 30) {
                        Q = P / O;
                        O = 4500
                        P = O * Q
                    }
                    if (100 < P / 30) {
                        Q = P / O;
                        P = 3000
                        O = P * Q
                    }

                    const width_height = { height: NImage.height, width: NImage.width }
                    self.props.handler(self.props.id, res, width_height)
                }
            },
            error: function (err) {
                alert(err)
            }
        });
    }

    render() {
        const { lgShowState, windowSizes, id } = this.props;

        const uploadedFile = windowSizes.getIn([id, 'uploadedFile']);

        var config = {};
        config.tools = ['resize', 'crop', 'adjust', 'effects', 'filters', 'rotate', 'text'];
        config.colorScheme = 'light';
        config.translations = {
            en: {
                'toolbar.resize': 'Image Resize',
                'toolbar.download': 'Frame It'
            }
        };

        return (
            <FilerobotImageEditor
                show={lgShowState}
                src={uploadedFile}
                onClose={this.toggleFalse}
                onBeforeComplete={this.saveImage}
                config={config}
            />
        );
    }
}